export const SITE_NAME = "MyWooflySitters";
